import { NgModule } from '@angular/core';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { LoginService } from './services/login.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './handlers/errors.interceptor';


@NgModule({
    providers: [
        AuthGuardService,
        LoginService,
        AuthService,
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true } 
    ]
})
export class SecurityModule {}
